import React from 'react';
import style from './index.module.scss';
import { ReloadOutlined } from '@ant-design/icons';

interface Props {
  title: string;
  children?: React.ReactNode;
  reload: (e: React.MouseEvent) => void;
}

const FatorBox: React.FC<Props> = ({ title, reload, children }) => {
  return (
    <div className={style.container}>
      <div className={style.header}>
        <span className={style.title}>{title}</span>
        <span className={style.icon} onClick={reload}>
          <ReloadOutlined />
        </span>
      </div>
      <div className={style.main}>{children}</div>
    </div>
  );
};

export default FatorBox;
